import { createContext, useState, useContext, ReactNode, useMemo } from 'react';

import { Loading } from '../components/Loading';

type ProviderProps = {
  children: ReactNode;
};

type AppContextProps = {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const AppContext = createContext<AppContextProps>({} as AppContextProps);

export function AppProvider({ children }: ProviderProps) {
  const [loading, setLoading] = useState(false);
  const contextValue = useMemo(() => ({ loading, setLoading }), [loading, setLoading]);

  return (
    <AppContext.Provider value={contextValue}>
      {children}
      <Loading shown={loading} />
    </AppContext.Provider>
  );
}

export const useApp: () => AppContextProps = () => useContext(AppContext);
